import React from 'react';
import { btnStyle } from '../../styles/theme';


function GearItem({ item, character, setCharacter, idx }) {
  function updateItem(updates) {
    const newGear = [...(character.gear || [])];
    newGear[idx] = { ...item, ...updates };
    setCharacter({ ...character, gear: newGear });
  }

  function deleteItem() {
    const newGear = character.gear.filter((_, i) => i !== idx);
    setCharacter({ ...character, gear: newGear });
  }

  return (
    <div style={{ background: "rgba(20,16,10,0.4)", border: "1px solid rgba(201,168,76,0.15)", borderRadius: 6, padding: "10px 12px", marginBottom: 8 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
        <input
          value={item.name}
          onChange={(e) => updateItem({ name: e.target.value })}
          placeholder="Gear name"
          style={{
            flex: 1,
            background: "rgba(0,0,0,0.3)",
            border: "1px solid rgba(201,168,76,0.2)",
            borderRadius: 4,
            padding: "6px 10px",
            color: "#c9a84c",
            fontSize: "13px",
            fontFamily: "'Cinzel', serif"
          }}
        />
        <button onClick={deleteItem} style={{ ...btnStyle("#c0392b", "transparent"), padding: "4px 8px", fontSize: "10px" }}>Delete</button>
      </div>
      <textarea
        value={item.description}
        onChange={(e) => updateItem({ description: e.target.value })}
        placeholder="Description / Effect"
        rows={2}
        style={{
          width: "100%",
          background: "rgba(0,0,0,0.3)",
          border: "1px solid rgba(201,168,76,0.2)",
          borderRadius: 4,
          padding: "6px 10px",
          color: "#a09070",
          fontSize: "11px",
          lineHeight: 1.4,
          resize: "vertical"
        }}
      />
    </div>
  );
}

export default GearItem
